import { inject, Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  CanMatch,
  Route,
  Router,
  RouterStateSnapshot,
  UrlSegment,
  UrlTree,
} from '@angular/router';
import { catchError, map, Observable, of } from 'rxjs';
import { UserManagementService } from 'src/app/core/api/management/user-management-api.service';
import { Role } from 'src/app/core/constants/role.enum';
import { UserStore } from 'src/app/core/stores/user.store';

@Injectable({
  providedIn: 'root',
})
export class SuperuserRouteGuard implements CanActivate, CanMatch {
  private readonly router = inject(Router);
  private readonly userStore = inject(UserStore);
  private readonly userManagementService = inject(UserManagementService);

  canActivate(
    _route: ActivatedRouteSnapshot,
    _state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | boolean | UrlTree {
    return this.resolveAccess();
  }

  canMatch(_route: Route, _segments: UrlSegment[]): Observable<boolean | UrlTree> | boolean | UrlTree {
    return this.resolveAccess();
  }

  private resolveAccess(): Observable<boolean | UrlTree> | boolean | UrlTree {
    const knownRole = this.userStore.userRole() ?? this.userStore.user().role;
    if (knownRole) {
      return this.checkAccessByRole(knownRole);
    }

    if (!this.userStore.isAuthorized()) {
      return this.router.parseUrl('/auth/sign-in');
    }

    return this.userManagementService.getCurrentUser().pipe(
      map(user => this.checkAccessByRole(user.role)),
      catchError(() => of(this.router.parseUrl('/homepage')))
    );
  }

  private checkAccessByRole(role: Role): boolean | UrlTree {
    return role === Role.SUPERUSER ? true : this.router.parseUrl('/homepage');
  }
}
